const tableTitleService = {
  title: 'Services',
  placeholder: 'Search',
  Typography: 'no results found'
};

export default tableTitleService;
